// Centralized route paths so renaming one route updates every Link/redirect.

export const ROUTES = {
  login: '/login',
  dashboard: '/',
  customers: '/customers',
  licenses: '/licenses',
  users: '/users',
  help: '/help',
  notFound: '*',
} as const;
